import { ai360 } from "../products/ai360";
import { aiDome } from "../products/aiDome";
import { aiDslr } from "../products/aiDslr";
import { aiLpr } from "../products/aiLpr";
import { aiMs4 } from "../products/aiMs4";
import { aiPro } from "../products/aiPro";
import { aiPtzIndustrial } from "../products/aiPtzIndustrial";
import { aiPtzPrecision } from "../products/aiPtzPrecision";
import { aiTurret } from "../products/aiTurret";
import { g4Instant } from "../products/g4Instant";
import { g5Bullet } from "../products/g5Bullet";
import { g5Dome } from "../products/g5Dome";
import { g5DomeUltra } from "../products/g5DomeUltra";
import { g5Flex } from "../products/g5Flex";
import { g5Pro } from "../products/g5Pro";
import { g5Ptz } from "../products/g5Ptz";
import { g5TurretUltra } from "../products/g5TurretUltra";
import { g6180 } from "../products/g6180";
import { g6Bullet } from "../products/g6Bullet";
import { g6Dome } from "../products/g6Dome";
import { g6Instant } from "../products/g6Instant";
import { g6Pro360 } from "../products/g6Pro360";
import { g6ProBullet } from "../products/g6ProBullet";
import { g6ProDome } from "../products/g6ProDome";
import { g6ProTurret } from "../products/g6ProTurret";
import { g6Ptz } from "../products/g6Ptz";
import { g6Turret } from "../products/g6Turret";
import { aiTheta } from "../products/theta";
import { aiThetaPro } from "../products/thetaPro";

export const physicalSecurityProducts = [
  /** Bullet */
  g6ProBullet,
  g6Bullet,
  g5Bullet,
  g5Pro,
  aiPro,
  aiDslr,
  aiLpr,
  /** Dome & Turret */
  g6ProDome,
  g6Dome,
  g6Pro360,
  g6180,
  g6ProTurret,
  g6Turret,
  aiMs4,
  aiTurret,
  aiDome,
  g5DomeUltra,
  g5TurretUltra,
  g5Dome,
  ai360,
  /** Compact */
  g6Instant,
  g5Flex,
  g4Instant,
  /** Interior Design */
  aiThetaPro,
  aiTheta,
  /** PTZ */
  aiPtzPrecision,
  aiPtzIndustrial,
  g6Ptz,
  g5Ptz,
];
